export * from './full-layout';
export * from './simple-layout';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/containers/index.ts